import { useMutation } from '@tanstack/react-query'
import { toast } from 'sonner'

import { useApi } from '@fortem-monorepo/react-spa'
import { API } from '@fortem-monorepo/web-sdk'

import { useUserContext } from '@/index'
import { toastApiError } from '@/lib/error-toast'

export const useUpdateStructuredProductMutation = () => {
  const api = useApi()

  return useMutation({
    mutationFn: (body: API.UpdateBody) => {
      return api.posmon.updateStructuredProduct(body)
    },
    onSuccess: (_data, _params) => {
      toast.success(`Successfully updated ${_params.oldValue} to ${_params.newValue}`)
    },
    onError: (error, _params) => {
      toastApiError(error, `Error updating ${_params.oldValue} to ${_params.newValue}`)
    },
  })
}

export const useUpdateHistoricalPricesMutation = () => {
  const api = useApi()

  return useMutation({
    mutationFn: (body: API.UpdateBody) => {
      return api.posmon.updateSecondaryHistorical(body)
    },
    onSuccess: (_data, _params) => {
      toast.success(`Successfully updated ${_params.oldValue} to ${_params.newValue}`)
    },
    onError: (error, _params) => {
      toastApiError(error, `Error updating ${_params.oldValue} to ${_params.newValue}`)
    },
  })
}

export const useSendSecondaryEmailMutation = () => {
  const api = useApi()

  const { user } = useUserContext()

  return useMutation({
    mutationFn: () => {
      return api.posmon.sendSecondaryEmail()
    },
    onSuccess: (_data, _params) => {
      toast.success(`Email sent to ${user.user?.email}`)
    },
  })
}
